import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { MainNavComponent } from './main-nav/main-nav.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { NavListComponent } from './main-nav/nav-list/nav-list.component';
import { LanguageWrapperComponent } from './language-wrapper/language-wrapper.component';

@NgModule({
  declarations: [
    MainNavComponent,
    MainHeaderComponent,
    NavListComponent,
    LanguageSelectorComponent,
    LanguageWrapperComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule
  ],
  exports: [
    MainNavComponent,
    MainHeaderComponent
  ]
})
export class MainModule { }
